module.exports = __webpack_public_path__ + "img/ring_r_l_0_0@2x.5a69d7e7.png";